import * as React from 'react'

const style = require('./Avatar.css')

interface User {
  id: string;
  firstName: string;
  lastName: string;
  smallAvatarUrl?: string;
}

interface Props {
  user?: User;
  className?: string;
}

const MILKYWAY_COLORS = [
  '#4E78F1', '#7091F2', '#A2CBFF', '#FC7455', '#FF8864', '#FF9D84',
  '#00A690', '#00C7AF', '#39D6B4', '#FDB624', '#FDC04C', '#FFD448',
]

const milkywayColor = (userId: string): string => {
  const seed = parseInt(userId.replace(/\D/g, ''), 10)
  return MILKYWAY_COLORS[seed % MILKYWAY_COLORS.length]
}

const avatarLetters = ({ firstName, lastName }) => (
  (lastName ? `${firstName[0]}${lastName[0]}` : firstName[0]).toUpperCase()
)

export const Avatar: React.FunctionComponent<Props> = ({ user, className }) => {
  if (!user || !user.id) return null

  const { id, firstName, smallAvatarUrl } = user
  const containerClassName = `${style.container} ${className || ''}`

  if (smallAvatarUrl) {
    return <img className={containerClassName} src={smallAvatarUrl} alt={firstName} />
  }

  return (
    <div className={containerClassName} style={{ backgroundColor: milkywayColor(id) }}>
      {avatarLetters(user)}
    </div>
  )
}
